import { render, staticRenderFns } from "./com-file-list.vue?vue&type=template&id=70a61099&scoped=true"
import script from "./com-file-list.vue?vue&type=script&lang=js"
export * from "./com-file-list.vue?vue&type=script&lang=js"
import style0 from "./com-file-list.vue?vue&type=style&index=0&id=70a61099&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a61099",
  null
  
)

export default component.exports